import { AutogenModelEquipmentMatch, AutogenRowEquipmentMatch } from "./autogen/AutogenModelEquipmentMatch";

export class ModelEquipmentMatch extends AutogenModelEquipmentMatch<RowEquipmentMatch> {
	constructor() {
		super(RowEquipmentMatch);
	}
}

export class RowEquipmentMatch extends AutogenRowEquipmentMatch {
}